import * as yup from "yup";
export const registerSchema = yup.object().shape({
  name: yup
    .string()
    .required("Digite seu nome")
    .min(3, "Seu nome deve conter no mínimo 3 caracteres"),
  email: yup
    .string()
    .required("Digite seu e-mail")
    .email("Digite um e-mail válido"),
  password: yup
    .string()
    .required("Digite sua senha")
    .min(8, "Sua senha deve conter no mínimo 8 caracteres"),
  confirmPassword: yup
    .string()
    .required("A confirmação da senha é obrigatória")
    .oneOf([yup.ref("password")], "As senhas não coincidem"),
});
